import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';

export default {
  maxHeight: 100, // Threshold where the "read-more" button appears
  title: 'Bibliografia',
  type: 'bibliography',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
    ],
    content: [
      {
        id: 'metadata',
        type: 'metadata',
        options: {
          hideLabels: true,
        }
      },
    ],
  },
} as ConfigMurucaResourceLayout;
